<script lang="ts">
    import { login } from "../../../store"
    import { getPriceCalculationByDealers } from "../../../api"
    import { _ } from "svelte-i18n"
    import Icon from "../../widgets/Icon.svelte"
    import { mdiPlusCircleOutline } from "@mdi/js"
    import { requireLogin } from "../../../helper"
    import PricecalcForm from "./PricecalcForm.svelte"
    import MiniLoader from "../../widgets/MiniLoader.svelte"

    export let lang = "de"
    requireLogin()
    let defaultPriceCalculation: PriceCalculation
    let priceGroups: PriceCalculation[]

    $: loginData = $login
    $: if (loginData) getPricingData()
    const getPricingData = () => {
        if (loginData?.account?.ident?.dealerNumber) {
            getPriceCalculationByDealers(loginData?.account?.ident?.dealerNumber)
                .then((response) => {
                    if (response.data.length) {
                        priceGroups = response.data.filter((e) => e.groupName !== null && e.groupName !== undefined)
                        defaultPriceCalculation = response.data.find(
                            (e) => e.groupName === null || e.groupName === undefined
                        )
                    } else {
                        priceGroups = []
                    }
                })
                .catch((e) => {
                    console.error(e)
                })
        }
    }
    function addGroup() {
        priceGroups.push({
            daysValid: null,
            dealerNumber: null,
            groupName: "",
            expiryDates: [],
            vat: null,
            globalCalculation: null,
            calculation: {
                discountPercent: null,
                surchargePercent: null,
                type: "surcharge",
            },
            exception: { rules: [] },
            ruleBasedCalculation: [],
        })
        priceGroups = priceGroups
    }
</script>

<section data-lang="{lang}" class="pcalc">
    <div class="container">
        <h1>{$_("components.pcalc.priceCalculation")}</h1>
        {#if Array.isArray(priceGroups)}
            <h2>{$_("components.pcalc.globalPriceCalculation")}</h2>
            <PricecalcForm global="{true}" priceCalculation="{defaultPriceCalculation}" />
            <h2>{$_("components.pcalc.priceGroups")}</h2>
            {#key priceGroups.length}
                {#each priceGroups as pCalc, i}
                    <PricecalcForm
                        bind:priceCalculation="{pCalc}"
                        on:refresh="{(e) => {
                            priceGroups[i] = e.detail
                        }}"
                        on:remove="{() => {
                            priceGroups = priceGroups.filter((e) => e !== pCalc)
                        }}"
                    />
                {/each}
            {/key}
            <div class="centerbtn">
                <button
                    type="button"
                    class="btn btn-primary btn-outline"
                    data-cy="add-pricegroup"
                    on:click="{addGroup}"
                >
                    <Icon path="{mdiPlusCircleOutline}" />
                    <span>{$_("components.pcalc.addPriceGroup")}</span>
                </button>
            </div>
        {:else}
            <MiniLoader />
        {/if}
    </div>
</section>
